// extracted by mini-css-extract-plugin
module.exports =  {"layout":"_2787e5dfdf--layout--dVaQU","spinner":"_2787e5dfdf--spinner--e_O7D","container":"_2787e5dfdf--container--M0xiL","error":"_2787e5dfdf--error--AcAkz"};